import {
    getJumps,
    OPEN_SSE_MAIN,
    OPEN_SSE_GAMES,
    getGames,
} from '../store/actions/sse.action';

import {
    OPEN_SSE_SCAN_BAND,
    getBandID,
    setBandScanned,
} from '../store/actions/scanBand.action.js';
import { baseUrl, rawBackendUrl } from '../api/config';
import {
    setBestOfTheDay,
} from '../store/actions/ranking.action';

const sseMiddleware = () => {
    let eventSource = null;
    let eventSourceBandScan = null;

    const onMessage = (store) => (event) => {

        if(event?.data === "No data available") {

        } else {
            const payload = JSON.parse(event?.data);
          //  console.log(payload)
            if (payload.hero) {
                store.dispatch(setBestOfTheDay(payload));
            }
            store.dispatch(getJumps(payload));
        }
    };

    const onMessageGames = (store) => (event) => {
        const payload = JSON.parse(event.data);
        store.dispatch(getGames(payload));
    };

    const onMessageScan = (store) => (event) => {
        const payload = JSON.parse(event.data);
        if (payload) {
            store.dispatch(getBandID(payload));
            store.dispatch(setBandScanned(true));
        }
    };

    const onError = (store) => (event)  => {
        // TODO: send info to backend or kibana
        console.log('EVENTSTREAM ERROR', event);

        if (eventSource !== null) {
            eventSource.close();
        }
        setTimeout(() => {
            eventSource = new EventSource(baseUrl + '/jumps-stream');
            eventSource.onmessage = onMessage(store);
            eventSource.onerror = onError(store);
        }, 10 * 1000)
        
        const today = new Date();
        const date =
            today.getDate() +
            '-' +
            (today.getMonth() + 1) +
            '-' +
            today.getFullYear();
        const time =
            today.getHours() +
            ':' +
            today.getMinutes() +
            ':' +
            today.getSeconds();
        window.localStorage.setItem(date + '-' + time, event);

    };

    return (store) => (next) => (action) => {
        switch (action.type) {
            case OPEN_SSE_MAIN:
                if (eventSource !== null) {
                    eventSource.close();
                }
                eventSource = new EventSource(baseUrl + '/jumps-stream');
                eventSource.onmessage = onMessage(store);
                eventSource.onerror = onError(store);
                break;

            case OPEN_SSE_SCAN_BAND:
                if (eventSourceBandScan !== null) {
                    eventSourceBandScan.close();
                }
                eventSourceBandScan = new EventSource(
                    'http://localhost:3005/stream'
                );
                eventSourceBandScan.onmessage = onMessageScan(store);
                eventSourceBandScan.onerror = onError(store);
                break;
            default:
                return next(action);
        }
    };
};

export default sseMiddleware();
